import styled from 'styled-components';
import { motion } from 'framer-motion';
import { GREEN_COLOR } from '../constants';

export const HeroSection = styled(motion.section)`
  position: relative;
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  overflow: hidden;
  background-color: #000;
  padding: 6rem 0;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1;
  }

  @media (max-width: 768px) {
    height: 65vh;
    padding: 2rem 0;
  }
`;

export const HeroVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
`;

export const HeroOverlay = styled.div`
  position: relative;
  z-index: 2;
  max-width: 1320px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: calc(100% - 4rem);
  margin: 4rem auto 0;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1.5rem;
    margin: 2rem auto 0;
  }
`;

export const HeroTitle = styled(motion.h1)`
  font-size: 4rem;
  font-weight: 700;
  line-height: 110%;
  width: 55%;
  color: white;
  margin: 0;
  letter-spacing: 1px;
  text-transform: uppercase;

  @media (max-width: 968px) {
    font-size: 3rem;
    width: 70%;
  }
  @media (max-width: 768px) {
    font-size: 2rem;
    width: 100%;
  }
`;

export const HeroSubtitle = styled(motion.p)`
  font-size: 1.25rem;
  color: #fff;
  padding: 1rem 1rem 0 0;
  font-weight: 500;
  text-align: left;
  margin: 0;
  margin-bottom: 1rem;
  line-height: 1.6;
  width: 55%;

  @media (max-width: 968px) {
    font-size: 1.1rem;
    width: 70%;
  }
  @media (max-width: 768px) {
    font-size: 1rem;
    width: 100%;
  }
`;

export const CtaButton = styled(motion.button)`
  background-color: #000;
  color: white;
  padding: 1.5rem 1.8rem;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: background-color 0.3s;
  margin: 1rem 0;

  &:hover {
    background-color: ${GREEN_COLOR};
  }

  @media (max-width: 768px) {
    padding: 1rem 1.4rem;
    font-size: 0.95rem;
  }
`;

export const CtaButtonSecondary = styled(CtaButton)`
  background-color: ${GREEN_COLOR};
  &:hover {
    background-color: #2e4a27;
  }
  text-decoration: none;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 0;
  width: 55%;
  gap: 1.2rem;
  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const StoreBadges = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-self: end;
  flex-wrap: wrap;
`;

export const StoreBadge = styled.img`
  height: 48px;
  width: auto;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    height: 42px;
  }
`;
